package io.github.jangalinski.pages._2014._10._19

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initOsxYosemitePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2014/10/19/OsxYosemite.md", FrontMatterElement.Builder { addScalar("title", "My new yosemite"); addScalar("description", "noteworthy after upgrading to 10.10"); addScalar("header-img", "/img/about-bg.jpg"); addScalar("date", "2014-10-19"); }))
}

@Page("/2014/10/19/osx-yosemite")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun OsxYosemitePage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After upgrading to Mac OSX 10.10 I found some smart tricks to tune the system that I log here.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://www.cultofmac.com/235806/get-rid-of-the-dashboard-in-mavericks-os-x-tips/") {
                org.jetbrains.compose.web.dom.Text("get rid of the dashboard")
            }
            org.jetbrains.compose.web.dom.Text(" - who needs it anyway?")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("defaults write com.apple.dashboard mcx-disabled -boolean true && killall Dock")
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://fix-macosx.com/") {
                org.jetbrains.compose.web.dom.Text("fix privacy")
            }
            org.jetbrains.compose.web.dom.Text(" - make safari and spotlight keep quiet about your search terms")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://www.aptgetupdate.de/2014/10/21/yosemite-nach-hause-telefonieren/") {
                org.jetbrains.compose.web.dom.Text("phone home (DE)")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("installation-from-bootable-usb") }) {
        org.jetbrains.compose.web.dom.Text("Installation from bootable USB")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://www.apfelkern.info/probleme-bei-mac-os-x-yosemite-installation-kann-nicht-verifiziert-werden/") {
                org.jetbrains.compose.web.dom.Text("can not verify installation file")
            }
            org.jetbrains.compose.web.dom.Text(" - this one is really annoying ...")
        }
    }
}
